"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FiX } from "react-icons/fi";
import { TestIdEnum } from "../../../tests/types";
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export const Modal = t0 => {
  const $ = _c(22);
  const {
    isOpen,
    onClose,
    title,
    children
  } = t0;
  const [isMounted, setIsMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] !== isOpen || $[1] !== onClose) {
    t1 = () => {
      setIsMounted(true);
      const handleEsc = event => {
        if (event.key === "Escape") {
          onClose();
        }
      };
      if (isOpen) {
        window.addEventListener("keydown", handleEsc);
        document.body.style.overflow = "hidden";
      }
      return () => {
        window.removeEventListener("keydown", handleEsc);
        document.body.style.overflow = "unset";
      };
    };
    t2 = [isOpen, onClose];
    $[0] = isOpen;
    $[1] = onClose;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!isOpen || !isMounted) {
    return null;
  }
  let t3;
  if ($[4] !== onClose) {
    t3 = <div className="fixed inset-0 bg-slate-900 bg-opacity-75 transition-opacity" onClick={onClose} />;
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== title) {
    t4 = <h3 className="text-lg font-semibold leading-6 text-slate-900 dark:text-white" id="modal-title">{title}</h3>;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FiX className="w-6 h-6" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== onClose) {
    t6 = <button onClick={onClose} data-testid={TestIdEnum.CloseModalButton} className="p-1 rounded-full text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors">{t5}</button>;
    $[9] = onClose;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="flex items-center justify-between border-b border-slate-200 dark:border-slate-700 px-6 py-4">{t4}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== children) {
    t8 = <div className="px-6 py-5">{children}</div>;
    $[14] = children;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <div className="fixed inset-0 z-10 w-screen overflow-y-auto"><div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"><div className="relative transform overflow-hidden rounded-lg bg-white dark:bg-slate-800 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">{t7}{t8}</div></div></div>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t3 || $[20] !== t9) {
    t10 = createPortal(<div className="relative z-50" aria-labelledby="modal-title" role="dialog" aria-modal="true">{t3}{t9}</div>, document.body);
    $[19] = t3;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};